import { Flex, Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import useScrollToTop from 'hooks/useScrollToTop';
import { DashboardSummaryProvider } from 'contexts/DashboardSummaryContext';
import Header from 'components/Header/Header';
import { GlobalToastAlert } from 'components/ToastAlert';
import { PageLoader } from 'components/Spin';
import { selectIsBrandDetailsExist } from 'services/brand/brandSelectors';
import styles from './Layout.module.scss';

function LayoutWithSider() {
  const location = useLocation();
  useScrollToTop(location.pathname);

  const isBrandDetailsExist = useAppSelector(selectIsBrandDetailsExist);

  if (!isBrandDetailsExist) {
    return <PageLoader />;
  }

  // DashboardSummaryProvider must wrap BOTH the Header (whose mobile
  // MenuDrawer renders SidebarMenu → useSidebarMenuItems →
  // useDashboardSummary) AND the Outlet (where the alerts dashboard
  // card lives). Wrapping at the WithSidebar level alone leaves the
  // mobile drawer outside the provider's scope and throws
  // "useDashboardSummary must be used inside <DashboardSummaryProvider>".
  return (
    <DashboardSummaryProvider>
      <Flex gap='middle' wrap='wrap'>
        <Layout className={styles.container}>
          <div className={styles.stickyContainer}>
            <Header />
            <GlobalToastAlert />
          </div>
          <Outlet />
        </Layout>
      </Flex>
    </DashboardSummaryProvider>
  );
}

export default LayoutWithSider;
